'use client';

import { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import ensurePostHogClientInitialized from './ensurePostHogClientInitialized';

const PostHogClientProvider = ({
  bootstrap,
  shouldUseCookielessMode = false,
  children,
}) => {
  useLayoutEffect(() => {
    if (!bootstrap) {
      return undefined;
    }

    ensurePostHogClientInitialized({
      bootstrap,
      shouldUseCookielessMode,
    }).catch(() => {
      // PostHog is optional telemetry; swallow init failures (ad blockers, etc.).
    });

    return undefined;
  }, [bootstrap, shouldUseCookielessMode]);

  return children;
};

PostHogClientProvider.propTypes = {
  bootstrap: PropTypes.shape({
    distinctID: PropTypes.string,
    featureFlags: PropTypes.object,
    featureFlagPayloads: PropTypes.object,
  }),
  shouldUseCookielessMode: PropTypes.bool,
  children: PropTypes.node,
};

export default PostHogClientProvider;
